import { SSC_SEM_API_URL } from "../../settings/config";
import { fetchKeywordResearchInProgress, fetchKeywordResearchSuccessful, fetchKeywordResearchFailed } from "./creators";
import { authRequest } from "../authorizedRequests";
import { getOffset } from "./selectors";

export const fetchKeywordResearch = (keyword, researchType, seoDb, offset = 0, orderBy = "vol", orderDir = "desc") => {
  return (dispatch, getState) => {
    if (getOffset(getState(), keyword, seoDb) > offset) {
      return Promise.resolve();
    }

    dispatch(fetchKeywordResearchInProgress(keyword, researchType, seoDb));

    const apiUrl = `${SSC_SEM_API_URL}/keyword-research?research_type=${researchType}&phrase=${keyword}&db=${seoDb}&order_by=${orderBy}&order_dir=${orderDir}&offset=${offset}`;

    authRequest(apiUrl, dispatch, getState)
      .then(response => {
        dispatch(fetchKeywordResearchSuccessful(keyword, researchType, seoDb, response));
      })
      .catch(_ => {
        dispatch(fetchKeywordResearchFailed(keyword, researchType, seoDb));
      });
  };
};
